module.exports = __webpack_public_path__ + "static/media/webapp.f043e433.png";